.edit-entity-modal {
    max-width: 600px;
    padding: 20px;
    box-sizing: border-box;
    height: 100%;
}
